import React, { useState, useEffect, useRef } from "react";
import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import SaveIcon from "@material-ui/icons/Save";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { useHistory, useParams } from "react-router-dom";
import _, { isEmpty, size } from "lodash";
import { Loading } from "../atoms";
import GridList from "@material-ui/core/GridList";
import GridListTile from "@material-ui/core/GridListTile";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { saveAs } from "file-saver";
import {
  actualizarRegistro,
  getIncidentsById,
  getCustomers,
  obternerRegistroxID,
} from "../utils/Actions";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
// Imports para imprimir
import LocalPrintshopIcon from "@material-ui/icons/LocalPrintshop";
import PrintButton from "./printButton";
import "./styles.css";
import ReactToPrint from "react-to-print";
import IconButton from "@material-ui/core/IconButton";

import MailOutlineIcon from "@material-ui/icons/MailOutline";
import { generatePasswordRand, sendEmail, validaremail } from "../utils/Utils";
import { ADMINEMAIL, getemail } from "../config/emails";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { Hidden } from "@material-ui/core";
const inintialState = {
  accountid: "",
  createAt: "",
  description: "",
  descriptionadmin: "",
  imagenes: [],
  title: "",
  user: "",
  userName: "",
};

export default function EditIncidents() {
  const [state, setstate] = useState(inintialState);
  const [visible, setVisible] = useState(false);
  const [open, setopen] = useState(false);
  const [img, setimg] = useState("");
  const [accountlist, setaccountlist] = useState([]);
  const [emails, setemails] = useState([]);
  //obtener email y enviar y ya.
  let history = useHistory();
  let { id } = useParams();
  const incidentsid = id.slice(4);

  const account = localStorage.getItem("Account");
  const accountJSON = JSON.parse(account);
  const { rol, accountAsigned, accountAsignedName, accountId } = accountJSON[0];
  console.log(accountJSON);

  useEffect(() => {
    (async () => {
      //setstate(await getIncidentsById(incidentsid).data);
      let resultado = [];
      const { data } = await getIncidentsById(incidentsid);
      console.log("DATA");
      console.log(data);
      const emailsdata = await getCustomers(data.accountId);
      emailsdata.data.forEach((item) => {
        resultado.push(item.email);
      });
      const emailaccount = await obternerRegistroxID(
        "Accounts",
        data.accountId
      );
      console.log("***************RESULTADO**************");
      if (size(emailaccount.data) > 0) {
        resultado.push(emailaccount.data.contactemail);
      }
      console.log(resultado.join(","));
      setstate(data);
      setemails(resultado);
    })();
  }, []);

  const onChange = (e) =>
    setstate({ ...state, [e.target.name]: e.target.value });

  const handleClose = () => {
    setopen(false);
  };

  const downloadimage = () => {
    saveAs(`${img}.jpg`, "image.jpg");
  };

  const save = async () => {
    const {
      accountid,
      createAt,
      description,
      descriptionadmin,
      imagenes: [],
      title,
      user,
      userName,
    } = state;

    if (isEmpty(title)) {
      alert("Debe ingresar un título");
    } else if (isEmpty(description)) {
      alert("Favor, no borre el valor de descripción");
    } else if (isEmpty(descriptionadmin)) {
      alert(
        "Favor introduzca una descripción de adminitrador para continuar con el proceso de envío al cliente."
      );
    } else {
      setVisible(true);
      const data = {
        title,
        description,
        descriptionadmin,
        updatedAt: new Date(),
        updatedBy: `${account[0].name} ${account[0].lastname}`,
        sent: true,
        status: 1,
      };
      const { statusresponse } = await actualizarRegistro(
        "Incidents",
        incidentsid,
        data
      );
      if (statusresponse) {
        const asunto = encodeURIComponent("Notificación de Nuevo Incidente");

        const body = `Se ha registrado un nuevo incidente. <br><br> Para ver los detalles a través de nuestra plataforma presione <a href="https://www.sayeretsecurity.net/">Aquí</a>.<br>`;

        const destino = encodeURIComponent(emails.join(","));

        const email = encodeURIComponent(body);

        await sendEmail(email, asunto, destino); // Descomentar eso cuando ya se defina
        alert(
          "Se ha actualizado el incidente y se le envío una notificación al cliente para su revisión"
        );
      } else {
        alert(
          "Ha ocurrido un error al actualizar datos, favor inténtelo nuevamente"
        );
      }
      setVisible(false);
      history.push("/incidents");
    }
  };

  // Tablas para imprimir

  const TableItems = [{}];

  const generateTableRow = () => {
    return (
      <div>
        <tr>
          <tr>
            <td>
              <span style={{ fontWeight: "bold" }}>Título del Incidente</span>
            </td>
          </tr>
          <tr>
            <td>{state.title}</td>
          </tr>
          <tr>
            <td>
              <span style={{ fontWeight: "bold" }}>Descripción</span>
            </td>
          </tr>
          <tr>
            <td>{state.descriptionadmin}</td>
          </tr>
          <tr>
            <td style={{ alignSelf: "center" }}>
              <img
                src={state.imagenes[0]}
                height="300px"
                width="300px"
                style={{ alignSelf: "center" }}
              />

              {/* <GridList cols={2}>
                {
                  <GridListTile cols={1}>
                    <img src={state.imagenes[1]} />
                  </GridListTile>
                }
              </GridList> */}
              {/* {state.imagenes && (
                <GridList cols={3}>
                  {state.imagenes.map((image) => (
                    <GridListTile key={image} cols={1}>
                      <img
                        src={image}
                        onClick={() => {
                          setopen(true);
                          setimg(image);
                        }}
                      />
                    </GridListTile>
                  ))}
                </GridList>
              )} */}
            </td>
            <td></td>
          </tr>
        </tr>
      </div>
    );
  };

  const tableRef = React.useRef();

  return (
    <>
      {/* Tabla oculta */}
      <Grid style={{ display: "none" }}>
        <table ref={tableRef}>
          <tbody>
            <tr>
              <th></th>
            </tr>
            {TableItems.map((item) => generateTableRow(item))}
          </tbody>
        </table>
      </Grid>
      <FormControl
        style={{
          backgroundColor: "#fff",
          borderRadius: 5,
          padding: 20,
          paddingBottom: 30,
          width: "100%",
        }}
      >
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          item
          xs={12}
        >
          <Grid item xs={4}>
            <Typography gutterBottom variant="h5">
              <IconButton>
                <ChevronLeftIcon onClick={() => history.goBack()} />
              </IconButton>
              Incidentes
            </Typography>
          </Grid>
          <Grid
            container
            justifyContent="flex-end"
            item
            xs={8}
            alignItems="center"
          >
            <Grid item xs={6} align="right">
              <Typography gutterBottom variant="h5">
                Imprimir
                <IconButton>
                  <ChevronRightIcon />
                </IconButton>
              </Typography>
            </Grid>
            <Grid item xs={6} align="right">
              <PrintButton refsToPrint={[tableRef]} name={state.title} />
              {/* <Button
                size="large"
                variant="contained"
                color="secondary"
                startIcon={<LocalPrintshopIcon />}
                onClick={save}
              >
                {state.title}
              </Button> */}
            </Grid>
          </Grid>
        </Grid>

        <Grid
          item
          xs={12}
          direction="column"
          justify="center"
          alignItems="center"
          container
          spacing={0}
          style={{ marginBottom: 20 }}
        ></Grid>
        <Grid container spacing={5}>
          <Grid item xs={12}>
            <TextField
              id="outlined-basic"
              label="Título"
              variant="outlined"
              fullWidth
              name="title"
              onChange={onChange}
              onSubmit={() => {
                console.log("salio");
              }}
              value={state.title}
              fullWidth
              disabled={rol == 4 ? true : false}
            />
          </Grid>
          {rol !== 4 && (
            <Grid item xs={12}>
              <TextField
                id="outlined-basic"
                label="Descripción"
                variant="outlined"
                fullWidth
                name="description"
                onChange={onChange}
                value={state.description}
                fullWidth
                multiline={true}
                rows={3}
              />
            </Grid>
          )}

          <Grid item xs={12}>
            <TextField
              id="outlined-basic"
              label={rol === 4 ? "Descripción" : "Descripción Admin"}
              variant="outlined"
              fullWidth
              name="descriptionadmin"
              onChange={onChange}
              multiline={true}
              rows={3}
              value={state.descriptionadmin}
              disabled={rol == 4 ? true : false}
            />
          </Grid>
          <Grid item xs={6}>
            {state.imagenes && (
              <GridList cols={3}>
                {state.imagenes.map((image) => (
                  <GridListTile key={image} cols={1}>
                    <img
                      src={image}
                      onClick={() => {
                        setopen(true);
                        setimg(image);
                      }}
                    />
                  </GridListTile>
                ))}
              </GridList>
            )}
          </Grid>
          {rol !== 4 && (
            <Grid
              item
              xs={12}
              direction="row"
              justify="center"
              alignItems="center"
              container
            >
              {!_.get(state, "sent", false) ? (
                <Button
                  size="large"
                  variant="contained"
                  color="secondary"
                  startIcon={<MailOutlineIcon />}
                  onClick={save}
                >
                  ENVIAR AL CLIENTE
                </Button>
              ) : (
                <Button
                  size="large"
                  variant="contained"
                  disabled
                  color="secondary"
                  startIcon={<MailOutlineIcon />}
                  onClick={save}
                >
                  GESTIÓN COMPLETA
                </Button>
              )}
            </Grid>
          )}
        </Grid>
        <Loading visible={visible} setVisible={setVisible} />

        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">Imagen</DialogTitle>
          <DialogContent>
            {/*<DialogContentText>
            To subscribe to this website, please enter your email address here.
            We will send updates occasionally.
           </DialogContentText>*/}
            <img src={img} style={{ width: 300, height: 300 }} />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cerrar
            </Button>

            <Button onClick={downloadimage} color="primary">
              Descargar
            </Button>
          </DialogActions>
        </Dialog>
      </FormControl>
    </>
  );
}
